import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Breadcrumb,
  Col,
  Row,
  Button,
  Alert,
} from "react-bootstrap";
import { ReactSortable } from "react-sortablejs";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";
import PropTypes from "prop-types";
import * as Sentry from "@sentry/react";

import FieldInput from "../../components/global/form/FieldInput";
import { goToHref, isFeatureEnabled } from "../../components/global/GlobalTools";
import html2canvas from "html2canvas";
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";

import ReportCardItemCreator from "../../components/reportCards/ReportCardItemCreator";
import SettingAveragingFormatModal from "./modals/SettingAveragingFormatModal";
import DraggableElements from "../../components/reportCards/DraggableElements";
import AssignmentDetails from "../../components/reportCards/AssignmentDetails";
import ConfirmDeleteModal from "./modals/ConfirmDeleteModal";
import NewTamplateModal from "./modals/NewTamplateModal";
import SaveChangesModal from "./modals/SaveChangesModal";
import CFWeightsModal, {
  getWeightsResponseError,
} from "./modals/CFWeightsModal";
import ModalConfirmDelete from "../../components/global/modals/ModalConfirmDelete";
import LeaveWithoutSavingModal from "./modals/LeaveWithoutSavingModal";

/** Services */
import { organizationGet } from "../../api/Organizations";
import {
  GetClassLevel,
  GetTemplates,
  CreateTemplate,
  UpdateTemplate,
  GetSchoolCycles,
  GetSubjects,
  GetTemplateWeights,
} from "../../api/ReportCards";

//Custom styles
const customStyles = {
  columnBase: {
    marginTop: "10px",
    height: screen.height - screen.height / 4,
  },
  columnTemplates: {
    marginTop: "10px",
    maxHeight: screen.height - screen.height / 4,
  },
  solidBackground: {
    background: "#FFFFFF",
    padding: "30px 20px",
    minHeight: "100%",
    border: "solid 1px #cccccc",
    borderRadius: "5px",
  },
  dropZone: {
    border: "1px solid #e7e7e7",
    padding: " 5px",
    borderRadius: "8px",
    minHeight: "200px",
  },
  period: {
    border: "solid 1px #cccccc",
    borderRadius: "8px",
  },
  etiqeutaCiclo: {
    backgroundColor: "#07c25f",
    color: "#ffffff",
    borderRadius: "3px",
    paddingLeft: "3px",
    paddingRight: "3px",
  },
};

const cycleDefault = {
  schoolLevels: [],
  grades: [],
  groups: [],
  levelSelected: 0,
  gradeSelected: 0,
  groupSelected: 0,
};
const prefix = process.env.REACT_APP_PREFIX;
const language = localStorage.getItem(`cmLanguage${prefix}`);

const ReportCardEditor = (props) => {
  const [t] = useTranslation(["reportCards", "global"]);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [showNewTamplateModal, setShowNewTamplateModal] = useState(false);
  const [showSettingAveraging, setshowSettingAveraging] = useState(false);
  const [currentCycles, setCurrentCycles] = useState(null);
  const [templateToDelete] = useState(null);
  const [showSaveChanges, setShowSaveChanges] = useState(false);
  const [reloadBaseList, setReloadBaseList] = useState(false);
  const [schoolCycles, setSchoolCycles] = useState([]);
  const [cycleSelected, setCycleSelected] = useState(cycleDefault);
  const [listFormatItems, setListFormatItems] = useState([
    {
      id: "0",
      type: "phantomElement",
      disabled: true,
      averaging: true,
    },
  ]);
  const [backupDefaulsClasses, setBackupDefaulsClasses] = useState([]);
  const [defaulsClasses, setDefaulsClasses] = useState([]);
  const [backupDefaulsSubjects, setBackupDefaulsSubjects] = useState([]);
  const [defaulsSubjects, setDefaulsSubjects] = useState([]);
  const [classFilter, setClassFilter] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [lockItemSorting, setLockItemSorting] = useState(true);
  const [editingGradingFormat, setEditingGradingFormat] = useState({});
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [organizationInfo, setOrganizationInfo] = useState({
    name: "",
    logoUrl: "",
  });
  const [templateInformation, setTemplateInformation] = useState({
    name: language === "english" ? "Blank Template" : "Plantilla en Blanco", //initial default value
    format: "",
    thumbnailUrl: "",
  });
  const [uniqueItems, setUniqueItems] = useState({});
  const [saving, setSaving] = useState(false);
  // error handler
  const [error, setError] = useState({ active: false, message: "" });
  const [templateId, setTemplateId] = useState(null);
  const [showObservations, setShowObservations] = useState(false);
  const [visiblePage, setVisiblePage] = useState(1);
  // const [numberOfSubjects, setNumberOfSubjects] = useState(0);
  const [availableAllocationValues, setAvailableAllocationValues] =
    useState(false);
  const [hasDevelopmentAreas, setHasDevelopmentAreas] = useState(false);
  const [groupedByDevelopmentAreas, setGroupedByDevelopmentAreas] =
    useState(false);
  const [activeAveragingSelectionMode, setActiveAveragingSelectionMode] =
    useState(false);
  const [showPartialGrades, setShowPartialGrades] = useState(false);
  const [showCFPartialAvg, setShowCFPartialAvg] = useState(false);
  const [showCFPeriodAvg, setShowCFPeriodAvg] = useState(false);
  const [showCFWeights, setShowCFWeights] = useState(false);
  const [showCFWeightsModal, setShowCFWeightsModal] = useState(false);
  // In-memory store of per-class weights: { [development_area_id]: { [class_id]: weight_percentage } }
  const [cfWeights, setCFWeights] = useState({});
  // True while loadAllCFWeights is in flight. Because the API is a full-replace
  // on save, saving before this finishes would send an incomplete cfWeights and
  // wipe the weights of any CF not yet loaded — used to disable "Guardar cambios".
  const [loadingCFWeights, setLoadingCFWeights] = useState(false);
  // Pending request to delete a class from a weighted CF (opens the confirm modal).
  // Shape: { developmentAreaId, executeRemoval } | null
  const [deleteClassRequest, setDeleteClassRequest] = useState(null);
  // Pending request to add a class to a weighted CF (opens the warning modal).
  // Shape: { executeUpdate } | null
  const [addClassToWeightedCFRequest, setAddClassToWeightedCFRequest] =
    useState(null);
  // Unsaved-changes guard. Signature of the last saved/loaded state; the editor
  // is "dirty" when the current signature differs from it. Bumping baselineVersion
  // recaptures the baseline (on load and after a successful save).
  const savedSignatureRef = useRef(null);
  // Signature of the editor as of the latest render. Kept in a ref so the
  // router block can compare it against the baseline at navigation time,
  // without depending on a value captured when the block was registered.
  const currentSignatureRef = useRef(null);
  // Signature of the content last rejected by a failed save (createNewTemplate/
  // updateTemplate). The user already saw that error, so leaving right after it
  // (without further edits) shouldn't trigger the leave-confirmation modal again
  // — but editing anything afterward changes the signature and re-arms it.
  const errorAcknowledgedSignatureRef = useRef(null);
  const [baselineVersion, setBaselineVersion] = useState(0);
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const unblockRef = useRef(null); // history.block() disposer
  const pendingLocationRef = useRef(null); // route the user tried to navigate to
  const leaveAfterSaveRef = useRef(null); // route to go to after "Guardar y salir"
  // One-shot bypass for navigation the app itself triggers (see
  // navigateBypassingGuard): the guard must not block our own redirects.
  const allowNextNavigationRef = useRef(false);

  //Sets the waiting time for a request to be made
  let [typingCallback, setTypingCallback] = useState(null);
  let [typingSearchSubject, settypingSearchSubject] = useState(null);

  const prefix = process.env.REACT_APP_PREFIX;
  const history = useHistory();

  // The unsaved-changes guard ships with this project, so it lives behind the
  // same FF: with the flag off the editor must behave exactly as before (no
  // router block, no beforeunload, no modal).
  const unsavedChangesGuardEnabled = isFeatureEnabled(
    "partial_averages_in_development_areas"
  );

  /**
   * Signature of the editable state used to detect unsaved changes. A single
   * comparison covers every mutation point (add/remove/reorder items, class
   * weights, name, switches) without instrumenting each handler. The transient
   * phantom element is filtered out so it never counts as a change.
   * @returns {string}
   */
  const buildEditorSignature = () =>
    JSON.stringify({
      items: (listFormatItems || [])
        .filter(
          (item) =>
            item.type !== "phantomElement" &&
            !(item.type === "subject" && !item.value) &&
            !(item.type === "main_subject" && !item.value)
        )
        .map((item) => {
          // classesIds is UI-only bookkeeping that refreshAvailableClassList
          // backfills onto already-placed main_subject items whenever the
          // available-classes list (re)loads (e.g. right after opening an
          // existing template for edit) - it's never sent to the API (see
          // saveTemplate), so a background refresh must not read as an edit.
          if (
            item.type === "main_subject" &&
            item.value &&
            Object.prototype.hasOwnProperty.call(item.value, "classesIds")
          ) {
            const value = { ...item.value };
            delete value.classesIds;
            return { ...item, value };
          }
          return item;
        }),
      cfWeights,
      name: templateInformation.name,
      showObservations,
      showPartialGrades,
      showCFWeights,
      showCFPartialAvg,
      showCFPeriodAvg,
    });

  const currentEditorSignature = buildEditorSignature();
  currentSignatureRef.current = currentEditorSignature;
  // Lazily seed the baseline on the very first render so the dirty check never
  // reads a false "true" against the initial null ref value before the effect
  // below runs.
  if (savedSignatureRef.current === null) {
    savedSignatureRef.current = currentEditorSignature;
  }

  /**
   * Live dirty check. Reads refs only, so it stays correct between renders: the
   * baseline is recaptured in a post-commit effect, and mutating a ref does not
   * schedule a render. Reading it at navigation time (instead of trusting a
   * boolean captured when the router block was registered) is what keeps the
   * leave-confirmation modal from firing after a successful save.
   * @returns {bool}
   */
  const hasUnsavedChangesNow = () =>
    unsavedChangesGuardEnabled &&
    currentSignatureRef.current !== savedSignatureRef.current &&
    currentSignatureRef.current !== errorAcknowledgedSignatureRef.current;

  // Recapture the baseline after the state settles on load and after a save
  // (bumping baselineVersion). Runs post-commit, so it reads the fresh state.
  // Also clears the error-acknowledged signature: a fresh baseline (loaded or
  // just saved) makes any previously acknowledged error stale.
  useEffect(() => {
    savedSignatureRef.current = currentSignatureRef.current;
    errorAcknowledgedSignatureRef.current = null;
  }, [baselineVersion]);

  // Warn before leaving with unsaved changes. beforeunload covers refresh, tab
  // close and cross-navigation to v1 (window.location); history.block covers
  // in-app react-router navigation (e.g. the "Atrás" button) with a custom modal.
  useEffect(() => {
    if (!unsavedChangesGuardEnabled) return undefined;
    const handleBeforeUnload = (event) => {
      if (hasUnsavedChangesNow()) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    // Registered once: the callback re-reads the live signature on every
    // navigation attempt instead of trusting a boolean captured at registration
    // time, which went stale as soon as the baseline was recaptured.
    // history v4 contract: returning false cancels the transition, returning
    // undefined lets it through (returning a string would pop window.confirm,
    // which we never want here).
    unblockRef.current = history.block((location) => {
      if (allowNextNavigationRef.current) {
        allowNextNavigationRef.current = false;
        return undefined; // app-driven navigation: let it through
      }
      if (!hasUnsavedChangesNow()) return undefined;
      pendingLocationRef.current = location;
      setShowLeaveModal(true);
      return false;
    });
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      if (unblockRef.current) {
        unblockRef.current();
        unblockRef.current = null;
      }
    };
  }, [history, unsavedChangesGuardEnabled]);

  /**
   * Navigates without tripping the unsaved-changes guard. Used for transitions
   * the app decides on its own (post-save redirect, "Salir sin guardar",
   * "Guardar y salir"), where the confirmation was already resolved — otherwise
   * the guard would block the application's own navigation.
   * @param {string} path
   * @param {bool} replace
   */
  const navigateBypassingGuard = (path, replace = false) => {
    allowNextNavigationRef.current = true;
    replace ? history.replace(path) : history.push(path);
  };

  /**
   * Navigates to the route the user tried to reach, bypassing the router block.
   */
  const goToPendingLocation = () => {
    const location = pendingLocationRef.current;
    pendingLocationRef.current = null;
    if (location) {
      navigateBypassingGuard(location.pathname + (location.search || ""));
    }
  };

  /** "Cancelar": stay in the editor. */
  const onStayInEditor = () => {
    pendingLocationRef.current = null;
    setShowLeaveModal(false);
  };

  /** "Salir sin guardar": discard changes and navigate away. */
  const onLeaveWithoutSaving = () => {
    setShowLeaveModal(false);
    goToPendingLocation();
  };

  /** "Guardar y salir": persist, then navigate on success (see updateTemplate). */
  const onSaveAndLeave = () => {
    leaveAfterSaveRef.current = pendingLocationRef.current;
    setShowLeaveModal(false);
    saveTemplate();
  };

  /**
   * After a successful save, completes a pending "Guardar y salir" navigation.
   */
  const finishPendingLeave = () => {
    const location = leaveAfterSaveRef.current;
    leaveAfterSaveRef.current = null;
    if (!location) return;
    navigateBypassingGuard(location.pathname + (location.search || ""));
  };

  /**
   * The Block element is extracted to identify if it no longer belongs to the list and remove it.
   * @param {object} evt
   */
  const deleteItem = (evt) => {
    if (!lockItemSorting) {
      return;
    }
    let draggedElement = evt.originalEvent.target;
    // waits for the "to" parameter in chromium-based browsers
    let sortableListElement = evt.originalTarget || evt.to;
    //Check if the element no longer exists in the list when the event occurred was of type dragging
    if (evt.originalEvent.type == "dragend") {
      // remove the item that is dropped out of the group
      if (
        sortableListElement !== draggedElement &&
        !sortableListElement.contains(draggedElement)
      ) {
        setReloadBaseList(true);
        let index = draggedElement.id;
        listFormatItems.splice(index, 1);
        setListFormatItems(listFormatItems);
        setReloadBaseList(false);
        uniqueItemWatchman();
        refreshAvailableClassList();
        refreshAvailableSubjectList();
        // update the subject counter
        // subjectCounter(listFormatItems);
      }
    }
  };

  /**
   * Remove an item using the x icon
   * @param {obj} item  represents the item to be deleted
   * @param {number} index determines the position of the element to be deleted
   */
  const removeItemByButton = (item, index) => {
    setReloadBaseList(true);
    listFormatItems.splice(index, 1);
    uniqueItemWatchman();
    setListFormatItems(listFormatItems);
    refreshAvailableClassList();
    refreshAvailableSubjectList();
    // update the subject counter
    // subjectCounter(listFormatItems);
    setTimeout(() => {
      setReloadBaseList(false);
    }, 0);
  };

  /**
   * Gets the classes used in the list and disables them from the possible choices
   */
  const refreshAvailableClassList = (
    lstFormatItems = false,
    defClassesParam = false,
    defSubjectsParam = false,
    returnData = false
  ) => {
    let listItems = lstFormatItems || [...listFormatItems];
    let defClasses = defClassesParam || [...defaulsClasses];
    let defSubjects = defSubjectsParam || [...defaulsSubjects];

    const result = listItems.filter(
      (item) => item.type === "subject" && item.value
    );
    // extract the classes from the development groups
    const developmentAreas = listItems.filter(
      (item) => item.type === "developmentArea" && item.classes.length
    );
    for (const element of developmentAreas) {
      for (let singleClass of element.classes) {
        if (singleClass.value?.value) result.push(singleClass);
      }
    }
    let subjectsSelected = listItems.filter(
      (item) => item.type === "main_subject" && item.value
    );

    for (let selectedSubject of subjectsSelected) {
      const found = defSubjects.findIndex(
        (subject) => subject.id == selectedSubject.value.id
      );
      if (found != -1) {
        selectedSubject.value.classesIds = defSubjects[found].classesIds;
      }
    }
    let classesInSubjectsSelected = [];
    for (const subject of subjectsSelected) {
      classesInSubjectsSelected = classesInSubjectsSelected.concat(
        subject.value.classesIds
      );
    }
    defClasses.forEach((element) => {
      element.options.forEach((sClass) => (sClass.isDisabled = false));
    });
    for (let group of defClasses) {
      for (let subject of result) {
        let found = group.options.findIndex(
          ({ value }) => value === subject.value.value
        );
        if (found != -1) {
          group.options[found].isDisabled = true;
        }
      }
      group.options.forEach((item) => {
        if (classesInSubjectsSelected.includes(parseInt(item.value))) {
          item.isDisabled = true;
        }
      });
    }
    if (returnData) {
      return defClasses;
    }
    // setDefaulsClasses(defClasses);
  };

  /**
   * Listens when a new item is added to the list and removes the dependency on the parent list
   * @param {array} list  -Arrangement of orderable items
   */
  const updateFormatList = (list) => {
    let newArray = [];
    //remove dependency of subobjects
    for (let item of list) {
      let obj = JSON.parse(JSON.stringify(item));
      newArray.push(obj);
    }
    setListFormatItems(newArray);
  };

  /**
   * Stores the value of the class selected by the AsyncSelect
   * @param {obj} item
   * @param {int} position
   */
  const selectClass = (item, position, positionInGroup) => {
    setReloadBaseList(true);
    // Save the selected class on the element
    let array = [...listFormatItems];
    // Save the selected class on the element
    if (positionInGroup != undefined) {
      // Select the class in the group of development areas
      array[position].classes[positionInGroup].value = item;
    } else {
      // Select the class in the list
      array[position].value = item;
      array[position].unicID = item.value;
      // Validate if the class has a development area
      if (item.developmentAreaID && groupedByDevelopmentAreas) {
        let found = array.findIndex(
          (element) =>
            element.type === "developmentArea" &&
            element.development_area_id == item.developmentAreaID
        );
        // Validate if the group already exists
        if (found == -1) {
          // Create a new group
          let newGroup = {
            id: "8",
            development_area_id: item.developmentAreaID,
            positionInList: position,
            type: "developmentArea",
            title: item.developmentAreaName,
            disabled: false,
            averaging: true,
            classes: [array[position]],
          };
          // Add the new group to the list
          array.splice(newGroup.positionInList, 0, newGroup);
          // Remove from the list the item that was added to the group
          array.splice(position + 1, 1);
        } else {
          /* Add to existing group */
          array[found].classes.push(array[position]);
          // Remove from the list the item that was added to the group
          array.splice(position, 1);
        }
      }
    }

    setListFormatItems(array);
    selectedClasses.push(item.gradeGroupLevelId || item.itemprogramLevelId);
    setSelectedClasses(selectedClasses);
    refreshAvailableClassList();
    refreshAvailableSubjectList();
    setTimeout(() => {
      setReloadBaseList(false);
    }, 0);
  };

  const selectSubjects = (item, position) => {
    setReloadBaseList(true);
    // Save the selected Subject on the element
    let array = [...listFormatItems];
    // Select the class in the list
    array[position].value = item;
    array[position].unicID = item.value;
    setListFormatItems(array);
    //TODO: guardar las materias seleccionadas
    refreshAvailableClassList();
    refreshAvailableSubjectList();
    // Reload Base List
    setTimeout(() => {
      setReloadBaseList(false);
    }, 0);
  };

  const refreshAvailableSubjectList = (
    lstFormatItems = false,
    defClassesParam = false,
    returnData = false
  ) => {
    let listItems = lstFormatItems || [...listFormatItems];
    let defSubjects = defClassesParam || [...defaulsSubjects];
    const classesSelected = listItems.filter(
      (item) => item.type === "subject" && item.value
    );
    const classesSelectedIds = classesSelected.map((item) => item.value.value);
    const subjectSelected = listItems.filter(
      (item) => item.type === "main_subject" && item.value
    );
    defSubjects.forEach((sSubject) => {
      sSubject.classesIds = sSubject.classes.map((item) => item.id);
      sSubject.isDisabled = false;
    });
    for (let subjectList of defSubjects) {
      for (let subject of subjectSelected) {
        if (subjectList.value == subject.value.value) {
          subjectList.isDisabled = true;
        }
      }
      //si algun id de clase de classesSelectedIds esta en el array de clases de la materia, se deshabilita
      for (let classId of classesSelectedIds) {
        if (subjectList.classesIds.includes(parseInt(classId))) {
          subjectList.isDisabled = true;
        }
      }
    }
    if (returnData) {
      return defSubjects;
    }
    // setDefaulsSubjects(defSubjects);
  };

  /**
   * Get the information of the current school cycle
   */
  const getCurrentCycle = () => {
    GetSchoolCycles().then((result) => {
      let data = result?.data?.data || [];
      let cycles = data.filter((cycle) => cycle.current == 1);
      //format cycles for essential data
      formatCycles(data);
      setCurrentCycles(cycles);
    });
  };

  const formatCycles = (cycles) => {
    const allCycles = cycles.map((cycle) => {
      return {
        id: cycle.id,
        name: cycle.school_cycle,
        collegesAndSchools: cycle.colleges_and_schools,
        schoolLevels: cycle.school_levels,
        grades: [],
        groups: [],
        levelSelected: 0,
        gradeSelected: 0,
        groupSelected: 0,
      };
    });

    if (allCycles.length) {
      //if levels exist, extract the grades and format the levels
      if (allCycles[0].schoolLevels.length) {
        allCycles[0].schoolLevels = allCycles[0].schoolLevels.map((level) => {
          return {
            id: level.id,
            school_level_name: level.school_level_name,
            grades: level.grades,
            has_development_areas: level?.has_development_areas || false,
          };
        });
      }
      //if there are grades, extract the groups
      if (allCycles[0].grades.length) {
        allCycles[0].groups = allCycles[0].grades[0].groups.map((group) => {
          return {
            id: group.id,
            name: group.name,
          };
        });
      }
      setCycleSelected(allCycles[0]);
    }
    setSchoolCycles(allCycles);
  };

  /**
   * Gets classes filtered by name
   * @param {string} input -Text referring to the class name
   * @param {func} callback -Function to return the content to where it is invoked
   * @param {string} filter -Text that locally filters classes by school level
   * @param {int} schoolCycleId -Id of the current cycle, used in the first load of the view
   */
  const getClass = (input = "", callback, filter = classFilter, cycles) => {
    let schoolCycles = currentCycles ? currentCycles : cycles;
    // extract only the ids of the cycles
    let data = {
      only_level_classes: true,
      search: input,
    };

    if (filter.type == "gradeGroupLevelId") {
      data.grade_group_grade_level_id = filter.value;
    } else if (schoolCycles?.length) {
      data.school_cycles_ids = schoolCycles.map((cicle) => cicle.id);
    }

    if (typingCallback) {
      clearTimeout(typingCallback);
    }
    typingCallback = setTimeout(() => {
      GetClassLevel(data).then((result) => {
        if (result.response?.data.error) {
          Sentry.captureException(
            Error(JSON.stringify(result.response.data.error))
          );
          return;
        }
        let data = result.data.data;
        // TODO: If you want to display all the groups in the class, you must use the getNameGroups function in the GlobalTools file and pass it the array containing all the groups as a value.
        let subjects = [];
        if (filter) {
          data = filterClasses(filter, data, true);
        }
        if (data && data.length) {
          for (let item of data) {
            let options = [];
            for (let singleClass of item.classes) {
              let title =
                singleClass.class_title != "" ? singleClass.class_title : "S/N";
              options.push({
                label: title,
                subjectLabel: " - " + singleClass.subject_name,
                value: singleClass.id,
                level: item.level,
                gradeLevelId: singleClass.grade_level_id,
                programLevelId: singleClass.program_id,
                schoolCycleId: singleClass.school_cycle_id,
                gradeGroupLevelId: singleClass.grade_group_level_id,
                developmentAreaID: singleClass?.development_area?.id || null,
                developmentAreaName:
                  singleClass?.development_area?.name || null,
              });
            }
            // si alguna clase tiene el campo developmentAreaID, se activa la bandera
            if (options.some((option) => option.developmentAreaID)) {
              setHasDevelopmentAreas(true);
            }
            let group = {
              label: item.level,
              options: options,
            };
            subjects.push(group);
          }
        }
        if (input === "") {
          setDefaulsClasses(subjects);
          setBackupDefaulsClasses(subjects);
        } else {
          subjects = filter.type != "gradeGroupLevelId" ? [] : subjects;
          subjects = refreshAvailableClassList(
            listFormatItems,
            subjects,
            false,
            true
          );
          callback(subjects);
        }
      });
    }, 1000);

    setTypingCallback(typingCallback);
  };
  /**
   * Receives an array of classes to filter by school level
   * @param {object} filter - Contains parameters type (parameters of the class) and value (id of the level)
   * @param {array} classArray - Array of all classes
   * @param {bool} apiOrigin - Identifies if the array comes directly from the api or if it is taken locally
   * @returns {array} - Array of filtered classes
   */
  const filterClasses = (
    filter,
    classArray = defaulsClasses,
    apiOrigin = false
  ) => {
    let filtered = [];
    let propClass = "";
    if (apiOrigin) {
      // Identifies the type of filter to be applied on the classes
      propClass =
        filter.type == "gradeGroupLevelId"
          ? "grade_group_level_id"
          : filter.type == "gradeLevelId"
          ? "gradeLevelId"
          : "program_id";
    } else {
      // Identifies the type of filter to be applied on the classes
      propClass =
        filter.type == "gradeGroupLevelId"
          ? "gradeGroupLevelId"
          : filter.type == "gradeLevelId"
          ? "gradeLevelId"
          : "programId";
    }
    classArray.forEach((groupClass) => {
      let classes = groupClass.classes || groupClass.options;
      let filteredClass = classes.filter(
        (classItem) => classItem[propClass] == filter.value
      );
      if (filteredClass.length) {
        groupClass.options = filteredClass;
        filtered.push(groupClass);
      }
    });
    return filtered;
  };

  const getSubjects = (input = "", callback, filter = classFilter, cycles) => {
    if (!filter) {
      callback([]);
      return;
    }
    let schoolCycles = currentCycles ? currentCycles : cycles;
    // extract only the ids of the cycles
    let data = {
      only_level_classes: true,
      search: input,
    };
    if (filter.type == "gradeGroupLevelId") {
      data.grade_group_grade_level_id = filter.value;
    } else if (schoolCycles?.length) {
      data.school_cycles_ids = schoolCycles.map((cicle) => cicle.id);
    }
    if (typingSearchSubject) {
      clearTimeout(typingSearchSubject);
    }
    typingSearchSubject = setTimeout(() => {
      GetSubjects(data).then((result) => {
        if (result.response?.data.error) {
          Sentry.captureException(
            Error(JSON.stringify(result.response.data.error))
          );
          return;
        }
        let data = result.data.data;
        let subjects = [];
        if (data && data.length) {
          for (let subject of data) {
            subject.label = subject.title;
            subject.value = subject.id;
          }
          subjects = data;
        }
        if (input === "") {
          setDefaulsSubjects(subjects); //TODO: base referencia
          setBackupDefaulsSubjects(subjects);
        } else {
          subjects = filter.type != "gradeGroupLevelId" ? [] : subjects;
          subjects = refreshAvailableSubjectList(
            listFormatItems,
            subjects,
            true
          );
          callback(subjects);
        }
      });
    }, 1000);

    settypingSearchSubject(typingSearchSubject);
  };

  /**
   * Get the templates available for the organization
   */
  const getTemplates = () => {
    GetTemplates().then((result) => {
      let data = result.data.data;
      setTemplateList(data);
    });
  };

  /**
   * Get template information by id
   * @param {int} id template id to get
   */
  const getTemplate = (id = templateId) => {
    GetTemplates({ id }).then((response) => {
      let template = response.data.data[0];
      let filter =
        template.grade_group_grade_level_id || template.programLevelId;
      let typeFilter =
        template.grade_group_grade_level_id != null
          ? "gradeGroupLevelId"
          : "programLevelId";
      let newFilter = {
        type: typeFilter,
        value: filter,
      };
      setClassFilter(newFilter);
      getClass("", false, newFilter, false);
      getSubjects("", false, newFilter, false);
      loadTemplate(template);
    });
  };

  /**
   * Puts a template in edit mode
   * @param {object} template
   */
  const loadTemplate = (template) => {
    // setClassFilter(false);
    setDefaulsClasses(backupDefaulsClasses);
    setDefaulsSubjects(backupDefaulsSubjects);
    template.editMode = true;
    setTemplateList(templateList);
    let lstFormatItems = formattingListFormat(template.format);
    setListFormatItems(lstFormatItems);
    refreshAvailableClassList(
      lstFormatItems,
      backupDefaulsClasses,
      backupDefaulsSubjects
    );
    refreshAvailableSubjectList(lstFormatItems, backupDefaulsSubjects);
    setTemplateInformation({
      name: template.name,
      id: template.id,
      gradeGroupGradeLevelId: template.grade_group_grade_level_id,
      has_comments: template.has_comments,
      thumbnailUrl: "",
      format: "",
    });
    setShowObservations(template.has_comments == 1);
    setShowPartialGrades(template.show_partial_results == 1);
    if (
      isFeatureEnabled("partial_averages_in_development_areas") &&
      isFeatureEnabled("Mostrar_Parciales_en_Boletas")
    ) {
      setShowCFPartialAvg(template.show_cf_partial_avg == 1);
      setShowCFPeriodAvg(template.show_cf_period_avg == 1);
    }
    // "Class Weights" is independent from partials: gate its load only by the FF.
    if (isFeatureEnabled("partial_averages_in_development_areas")) {
      setShowCFWeights(template.show_cf_weights == 1);
      // Preload every CF's saved weights so the preview can show the % next to
      // each class without opening the editor modal.
      if (template.show_cf_weights == 1) {
        loadAllCFWeights(template.id, true);
      }
    }
    // A freshly loaded template is the clean baseline for the unsaved-changes
    // guard. Weights load asynchronously and bump the baseline again on arrival.
    setBaselineVersion((version) => version + 1);
  };

  /**
   * Loads the saved per-class weights of every CF in an existing template and
   * stores them in the in-memory cfWeights map, so the preview can render the %
   * next to each class without opening the modal. Issues a single GET with only
   * template_id; the API returns all areas at once.
   * The GET is the authoritative source for the whole template, so its result
   * REPLACES cfWeights entirely (including clearing it to {} when the API comes
   * back empty) instead of merging into whatever was in memory — otherwise a
   * stale local CF (e.g. left over from before the switch was turned off) would
   * never get cleared once the backend no longer has it.
   * Gated by the caller behind the FF + the Class Weights switch.
   * @param {int|string} templateId
   * @param {bool} foldIntoBaseline true only when the load is part of opening
   * the template, so the arriving weights count as already-saved state
   */
  const loadAllCFWeights = (templateId, foldIntoBaseline = false) => {
    if (!templateId) return;
    setLoadingCFWeights(true);
    GetTemplateWeights(templateId)
      .then((result) => {
        if (getWeightsResponseError(result)) return;
        const areas = (result && result.data) || [];
        const next = {};
        if (Array.isArray(areas)) {
          areas.forEach((area) => {
            if (!area.dev_area_id || !Array.isArray(area.class_weights)) return;
            const classesMap = {};
            area.class_weights.forEach((item) => {
              if (item.weight_percentage != null) {
                classesMap[String(item.class_id)] = item.weight_percentage;
              }
            });
            if (Object.keys(classesMap).length) {
              next[String(area.dev_area_id)] = classesMap;
            }
          });
        }
        setCFWeights(next);
        // Weights just arrived: fold them into the unsaved-changes baseline so
        // the async load is not mistaken for a user edit. Only when the load is
        // part of opening the template — when the user turns the switch on, the
        // load belongs to an edit in progress and adopting it as the baseline
        // would silently swallow whatever else was still pending.
        if (foldIntoBaseline) setBaselineVersion((version) => version + 1);
      })
      .catch(() => null)
      .finally(() => setLoadingCFWeights(false));
  };

  /**
   * format the items of the format parameter that comes from the api
   * @param {obj} objFormat
   * @returns {array} array of editable items
   */
  const formattingListFormat = (objFormat) => {
    let format = JSON.parse(objFormat);
    format.forEach((element, index) => {
      if (element.type === "subject") {
        let value = {
          value: element.values.id,
          label: element.values.name,
        };
        format[index].name = element.values.name;
        format[index].value = value;

        //Obtain and apply class filter
        let classFound = false;
        backupDefaulsClasses.every((groupClass) => {
          let classes = groupClass.options;
          classFound = classes.find(
            (singleClass) => singleClass.value == element.values.id
          );
          if (classFound) {
            let typeFilter =
              classFound.gradeLevelId != null
                ? "gradeLevelId"
                : "programLevelId";
            let filter = classFound.gradeLevelId || classFound.programLevelId;
            setDefaulsClasses(
              filterClasses(
                {
                  type: typeFilter,
                  value: filter,
                  schoolCycleId: classFound.schoolCycleId,
                },
                backupDefaulsClasses
              )
            );
            return;
          }
        });
      }
      if (element.type === "main_subject") {
        let value = {
          id: element.values.id,
          name: element.values.name,
          value: element.values.id,
          label: element.values.name,
          // classesIds: element.values.classes_ids,
        };
        format[index].name = element.values.name;
        format[index].value = value;
      }
      if (element.type === "average") {
        let averageFormat = element.values.average_format;
        averageFormat.averageNumberFormat = {
          value: averageFormat.average_number_format,
          label:
            averageFormat.average_number_format == "int"
              ? t("reportCards:settingAveragingFormatModal.integerNumbers")
              : t("reportCards:settingAveragingFormatModal.decimalNumbers"),
        };
        averageFormat.gradePeriodFormat = {
          value: averageFormat.grade_period_format,
          label:
            averageFormat.grade_period_format == "int"
              ? t("reportCards:settingAveragingFormatModal.integerNumbers")
              : t("reportCards:settingAveragingFormatModal.decimalNumbers"),
        };
        averageFormat.decimalsToUse = {
          value: averageFormat.decimals_to_use,
          label: averageFormat.decimals_to_use,
        };
        averageFormat.averageRounding = averageFormat.average_rounding;
        averageFormat.doNotRound = averageFormat.do_not_round;

        format[index].values.averageClasses = element.values.average_classes;
        format[index].values.averageFormat = averageFormat;

        format[index].value = averageFormat;

        //mark the classes selected on the basis of the ids array
        let averagingClasses = element.values.average_classes;
        averagingClasses.forEach((classId) => {
          // identify the position of the averaging class
          const classPosition = format.findIndex(
            (item) => item.type == "subject" && item.values.id == classId
          );

          // value to checkbox
          if (classPosition != -1) {
            format[classPosition].averaging = true;
          } else {
            // This class is in a group and already has the parameter averaging, there is no action to be taken
          }
        });
      }
      if (element.type === "developmentArea") {
        setGroupedByDevelopmentAreas(true);
      }
      // refreshAvailableClassList();
      // refreshAvailableSubjectList();
    });
    return format;
  };

  /**
   * Take a screenshot of the template editing section
   */
  const takeThumbnail = async () => {
    let node = document.querySelector("#templateContainer");
    let options = {
      allowTaint: true,
      useCORS: true,
      imageTimeout: 0,
      scale: 0.5,
    };
    /**
     * (await) Waits for the promise and then returns the generated value
     * (html2canvas) method captures an element to render it on a canvas
     */
    return await html2canvas(node, options).then((canvas) => {
      //The promise is created where the captured container will be returned in jpg image format in base 64
      let dataURL = canvas.toDataURL("image/jpeg");
      return dataURL;
    });
  };

  /**
   * Retrieves the fragmented data to assemble the template
   */
  const saveTemplate = async () => {
    let template = { ...templateInformation };
    let listItems = [...listFormatItems];
    setSaving(true);
    let items = [];
    let classIdsGroup = [];
    let subjectsIdsGroup = [];
    let hasClasses = false;
    //remove item stabilizer if it exists
    let position = listItems.findIndex(({ type }) => type == "phantomElement");
    if (position != -1) {
      listItems.splice(position, 1);
    }
    //remove empty class selectors
    for (let pos = listItems.length - 1; pos >= 0; pos--) {
      if (listItems[pos].type === "subject" && !listItems[pos].value) {
        listItems.splice(pos, 1);
      }
    }
    // remove empty subjects
    for (let pos = listItems.length - 1; pos >= 0; pos--) {
      if (listItems[pos].type === "main_subject" && !listItems[pos].value) {
        listItems.splice(pos, 1);
      }
    }
    for (let pos in listItems) {
      let obj = {
        order: parseInt(pos),
        type: listItems[pos].type,
      };
      if (listItems[pos].type === "subject" && listItems[pos].value) {
        // groups the ids of the classes for each average item
        hasClasses = true;
        if (listItems[pos].averaging) {
          classIdsGroup.push(listItems[pos].value.value);
        }
        let subjectValue = {
          id: listItems[pos].value.value,
          name: listItems[pos].value.label,
          // CM-52604: keep the CF link when saving a flat subject. An ungrouped
          // subject may carry its developmentAreaID only in `.values` (from the
          // loaded format) and not in `.value`; fall back to `.values` and to the
          // current class catalog so toggling the group switch never nulls it.
          developmentAreaID:
            listItems[pos].value.developmentAreaID ??
            listItems[pos].values?.developmentAreaID ??
            resolveClassDevArea(listItems[pos].value.value).id,
          developmentAreaName:
            listItems[pos].value.developmentAreaName ??
            listItems[pos].values?.developmentAreaName ??
            resolveClassDevArea(listItems[pos].value.value).name,
        };
        obj.values = subjectValue;
        obj.averaging = listItems[pos].averaging;
      }
      if (listItems[pos].type === "main_subject") {
        hasClasses = true; // flag to validate if there are classes selected
        if (listItems[pos].value) {
          subjectsIdsGroup.push(listItems[pos].value.value);
        }
        obj.values = {
          id: parseInt(listItems[pos].value.value),
          name: listItems[pos].value.label,
        };
      }
      if (listItems[pos].type === "average") {
        // The structure expected to be validated by the api is created
        let averageFormat = {
          grade_period_format: listItems[pos].values.averageFormat
            .gradePeriodFormat.value
            ? listItems[pos].values.averageFormat.gradePeriodFormat.value
            : "",
          average_number_format: listItems[pos].values.averageFormat
            .averageNumberFormat.value
            ? listItems[pos].values.averageFormat.averageNumberFormat.value
            : "",
          decimals_to_use: listItems[pos].values.averageFormat.decimalsToUse
            .value
            ? listItems[pos].values.averageFormat.decimalsToUse.value
            : "",
          average_rounding:
            listItems[pos].values.averageFormat.averageRounding != ""
              ? parseFloat(listItems[pos].values.averageFormat.averageRounding)
              : "",
          do_not_round: !!listItems[pos].values.averageFormat.doNotRound,
        };
        obj.values = {
          average_format: averageFormat,
          average_classes: classIdsGroup,
          average_subjects: subjectsIdsGroup,
          name: listItems[pos].values.name,
        };
        // reset the group for each average found
        classIdsGroup = [];
        subjectsIdsGroup = [];
      }
      if (listItems[pos].type === "groupAverage") {
        obj.values = listItems[pos].values;
      }
      if (listItems[pos].type === "developmentArea") {
        hasClasses = true;
        obj.development_area_id = listItems[pos].development_area_id;
        obj.title = listItems[pos].title;
        obj.subjects = listItems[pos].classes.map((item, index) => {
          return {
            averaging: item.averaging,
            order: index,
            type: "subject",
            values: {
              id: item.value.value,
              name: item.value.label,
              developmentAreaID: listItems[pos].development_area_id,
              developmentAreaName: item.value.developmentAreaName,
            },
          };
        });
        // Add class ids for averaging
        obj.subjects.forEach((item) => {
          if (item.averaging) {
            classIdsGroup.push(item.values.id);
          }
        });
      }
      items.push(obj);
    }
    template.thumbnail_url = await takeThumbnail();
    template.format = JSON.stringify(items);
    // template.school_cycle_id = currentCycleData.id;
    if (classFilter) {
      let levelId =
        classFilter.type == "gradeLevelId"
          ? "grade_level_id"
          : "program_level_id";
      template[levelId] = classFilter.value;
    }
    // if you do not have classes, an alert will be launched
    if (!hasClasses) {
      leaveAfterSaveRef.current = null;
      setShowSaveChanges(false);
      setSaving(false);
      printError(t("reportCards:page.noSubjectSelected"));
      return;
    }
    if (template.gradeGroupGradeLevelId) {
      template.grade_group_grade_level_id = template.gradeGroupGradeLevelId;
      delete template.program_level_id;
    }
    // Per-class weights travel in the template body so format + weights persist
    // together (atomically) on both create and update. The key is always sent
    // when the FF is on (never omitted): omitting it tells the API "don't touch
    // existing weights", but turning the switch off means the user no longer
    // wants weighting on this template, so we explicitly send [] to clear it —
    // otherwise stale rows would linger server-side. When the switch is on we
    // always send the full array — even empty — so the API can full-replace and
    // drop the weights of CFs that no longer apply (e.g. a class was removed).
    if (isFeatureEnabled("partial_averages_in_development_areas")) {
      template.class_weights = showCFWeights ? buildClassWeightsPayload() : [];
    }
    //create or update the template
    template.id ? updateTemplate(template) : createNewTemplate(template);
  };

  /**
   * Builds the class_weights payload for the template body from the in-memory
   * store: [{ development_area_id, classes: [{ class_id, weight_percentage }] }].
   * Object keys are always strings in JS; cast back to Number so the API
   * receives the same numeric shape as the rest of the contract (avoids
   * err_parameter_type on a strict backend type check).
   * @returns {array}
   */
  const buildClassWeightsPayload = () =>
    Object.keys(cfWeights).map((areaId) => ({
      development_area_id: Number(areaId),
      classes: Object.keys(cfWeights[areaId]).map((classId) => ({
        class_id: Number(classId),
        weight_percentage: cfWeights[areaId][classId],
      })),
    }));

  /**
   * Method for creating a new template
   * @param {obj} template
   */
  const createNewTemplate = (template) => {
    CreateTemplate(template).then((result) => {
      if (result.error) {
        const errorDescription = formattedErrorTemplate(result.error);
        printError(errorDescription);
        Sentry.captureException(Error(JSON.stringify(result.error)));
        leaveAfterSaveRef.current = null;
        setShowSaveChanges(false);
        setSaving(false);
        // The user already saw this error; don't nag them again with the
        // leave-confirmation modal unless they edit something else first.
        errorAcknowledgedSignatureRef.current = currentSignatureRef.current;
        return;
      }
      let data = result.data || null;
      if (data) {
        // The guard is still armed here (the baseline is only recaptured in the
        // post-commit effect below), so this redirect must bypass it or the
        // editor would block its own navigation and pop the leave modal.
        // replace, not push: /new is a dead route once the template exists, and
        // going Back to it would reopen an empty editor.
        navigateBypassingGuard(`/settings/report_cards/${data[0].id}`, true);
        setAvailableAllocationValues(true);
        // Keep the editor consistent with the route it just moved to: without
        // this the header button would still read "Guardar" instead of
        // "Guardar cambios".
        setTemplateId(data[0].id);
        setListFormatItems(formattingListFormat(data[0].format));
        setTemplateInformation({
          name: data[0].name,
          id: data[0].id,
          gradeGroupGradeLevelId: data[0].grade_group_grade_level_id,
          has_comments: data[0].has_comments,
          thumbnailUrl: "",
          format: "",
        });
      }
      getTemplates();
      setShowSaveChanges(false);
      setSaving(false);
      // Saved: reset the unsaved-changes baseline. (A new template already
      // navigated to its edit route above, so there is no pending leave.)
      leaveAfterSaveRef.current = null;
      setBaselineVersion((version) => version + 1);
    });
  };

  /**
   *Method for update a template
   * @param {obj} template
   */
  const updateTemplate = (template) => {
    UpdateTemplate(template).then((result) => {
      if (result.error) {
        const errorDescription = formattedErrorTemplate(result.error);
        printError(errorDescription);
        Sentry.captureException(Error(JSON.stringify(result.error)));
        leaveAfterSaveRef.current = null;
        setShowSaveChanges(false);
        setSaving(false);
        // The user already saw this error; don't nag them again with the
        // leave-confirmation modal unless they edit something else first.
        errorAcknowledgedSignatureRef.current = currentSignatureRef.current;
        return;
      }
      let data = result.data || null;
      if (data) {
        setListFormatItems(formattingListFormat(data[0].format));
        setTemplateInformation({
          name: data[0].name,
          id: data[0].id,
          gradeGroupGradeLevelId: data[0].grade_group_grade_level_id,
          has_comments: data[0].has_comments,
          thumbnailUrl: "",
          format: "",
        });
      }
      getTemplates();
      setShowSaveChanges(false);
      setSaving(false);
      // Saved: reset the unsaved-changes baseline and finish any pending
      // "Guardar y salir" navigation.
      setBaselineVersion((version) => version + 1);
      finishPendingLeave();
    });
  };

  /**
   * Stores the per-class weights of a single CF edited in the modal in memory.
   * Nothing is persisted here: the weights travel in the template body when the
   * user clicks "Guardar cambios" (see saveTemplate), so format and weights are
   * always saved together (atomically) and can never drift apart.
   * @param {int} developmentAreaId
   * @param {array} classes [{ class_id, weight_percentage }]
   */
  const onSaveCFWeights = (developmentAreaId, classes) => {
    const classesMap = classes.reduce((accumulator, singleClass) => {
      accumulator[String(singleClass.class_id)] = singleClass.weight_percentage;
      return accumulator;
    }, {});
    setCFWeights((previous) => ({
      ...previous,
      [developmentAreaId]: classesMap,
    }));
    return { success: true };
  };

  /**
   * Opens the confirmation modal before deleting a class that belongs to a
   * weighted CF. Invoked only from the weighted layout in ReportCardItemCreator.
   * Gated behind the FF at the call site.
   * @param {object} payload { developmentAreaId, executeRemoval }
   */
  const requestDeleteWeightedClass = (payload) => {
    setDeleteClassRequest(payload);
  };

  /**
   * Opens the warning modal before adding a class to a CF that already has
   * saved weights. The user must confirm to proceed.
   * @param {object} payload { executeUpdate }
   */
  const requestAddClassToWeightedCF = (payload) => {
    setAddClassToWeightedCFRequest(payload);
  };

  /**
   * Removes the in-memory weights of a CF (drops the % shown in the preview).
   * @param {int|string} developmentAreaId
   */
  const clearCFWeightsFromMemory = (developmentAreaId) => {
    setCFWeights((previous) => {
      if (!(developmentAreaId in previous)) return previous;
      const next = { ...previous };
      delete next[developmentAreaId];
      return next;
    });
  };

  /**
   * Handles toggling the "Ponderación de Clases (%)" switch. Turning it off
   * must also clear cfWeights from memory immediately: otherwise the stale
   * values stay in state, and if the switch is turned back on before the
   * template is reloaded, loadAllCFWeights would have nothing to overwrite
   * them with as soon as the backend still has (or already cleared) matching
   * data, and the preview would show old percentages that are no longer
   * accurate. Turning it on re-fetches from the backend via onEnableCFWeights.
   * @param {bool} newShowCFWeights
   */
  const handleShowCFWeightsChange = (newShowCFWeights) => {
    setShowCFWeights(newShowCFWeights);
    if (!newShowCFWeights) {
      setCFWeights({});
    }
  };

  /**
   * Confirms the deletion of a class from a weighted CF. Removing a class drops
   * the whole CF weighting (the remaining classes would no longer sum 100%), so
   * we clear it from the in-memory store and remove the class from the list. The
   * change is persisted when the user clicks "Guardar cambios": the template body
   * then carries the updated class_weights (without this CF), keeping format and
   * weights consistent.
   */
  const confirmDeleteWeightedClass = () => {
    if (!deleteClassRequest) return;
    const { developmentAreaId, executeRemoval } = deleteClassRequest;
    clearCFWeightsFromMemory(developmentAreaId);
    executeRemoval();
    setDeleteClassRequest(null);
  };


  /*
   * Format error when create/update a template
   * @param {object} { code, description }
   * @return {string}
   */
  const formattedErrorTemplate = ({ code, description }) => {
    const invalidId = t("reportCards:saveChangesModal.error");
    const isErrInvalidIdCode = code === "err_invalid_id";
    const errorDescription = isErrInvalidIdCode ? invalidId : description;
    return errorDescription;
  };

  /**
   * Get the organization's data for displaying the card file
   */
  const getOrganization = () => {
    organizationGet().then((result) => {
      let { name, logo_image_url: logoImageUrl } = result.data.data[0];
      let organizationInfo = {
        name: name,
        logoUrl: logoImageUrl,
      };
      setOrganizationInfo(organizationInfo);
    });
  };

  /**
   * Send to the average configuration object modem assigning the current position.
   * @param {obj} formatAverage
   * @param {int} position
   */
  const editAveragingFormat = (formatAverage, position) => {
    formatAverage.averageFormat.position = position;
    setEditingGradingFormat(formatAverage);
    setshowSettingAveraging(true);
  };

  /**
   * Save the averaging configuration in the item it belongs to
   * @param {obj} formatAverage
   * @param {int} position
   */
  const saveAverageformat = (formatAverage, position) => {
    let array = [...listFormatItems];
    array[position].values.averageFormat = formatAverage;
    setListFormatItems(listFormatItems);
    setTimeout(() => {
      setReloadBaseList(false);
    }, 0);
    setshowSettingAveraging(false);
  };

  /**
   * Change the list of items (classes) in checkbox selection mode for averaging
   * @param {bool} show - Switch to activate or deactivate selection mode
   * @param {int} pos - Indicates the position from which the selection mode will start.
   */
  const changeClassesSelectionMode = (show, pos) => {
    setReloadBaseList(true);
    let index = pos - 1;
    let item = {};
    listFormatItems[pos].selectionMode = show;
    // Change in checkbox mode only the classes below the selected average item position
    do {
      item = listFormatItems[index];
      if (item.type === "subject" || item.type === "developmentArea") {
        listFormatItems[index].selectionMode = show;
      }
      index = index - 1;
    } while (index > -1 && item.type != "average");
    // Disable all items in the list so as not to cross events
    listFormatItems.forEach((item) => (item.disabled = show));
    setListFormatItems(listFormatItems);
    setshowSettingAveraging(!show);
    setLockItemSorting(!show);
    // Evaluate if any average item has the selection mode active
    let activeSelectionMode = listFormatItems.some(
      (item) => item.type == "average" && item.selectionMode
    );
    setActiveAveragingSelectionMode(activeSelectionMode);

    setTimeout(() => {
      setReloadBaseList(false);
    }, 0);
  };

  /**
   * Add or remove class ids from the array used for averaging
   * @param {int} classId
   * @param {int} positionClass - current position of the selected class
   */
  const selectClassesForAveraging = (
    classId,
    positionClass,
    positionInGroup
  ) => {
    setReloadBaseList(true);
    let pos = listFormatItems.findIndex(
      (item) => item.type == "average" && item.selectionMode
    );
    if (positionInGroup != undefined) {
      listFormatItems[positionClass].classes[positionInGroup].averaging =
        !listFormatItems[positionClass].classes[positionInGroup].averaging;
      if (listFormatItems[positionClass].classes[positionInGroup].averaging) {
        listFormatItems[pos].values.averageClasses.push(classId);
      } else {
        const index = listFormatItems[pos].values.averageClasses.findIndex(
          (averageClass) => averageClass === classId
        );
        listFormatItems[pos].values.averageClasses.splice(index, 1);
      }
    } else {
      listFormatItems[positionClass].averaging =
        !listFormatItems[positionClass].averaging;
      if (listFormatItems[positionClass].averaging) {
        listFormatItems[pos].values.averageClasses.push(classId);
      } else {
        const index = listFormatItems[pos].values.averageClasses.findIndex(
          (averageClass) => averageClass === classId
        );
        listFormatItems[pos].values.averageClasses.splice(index, 1);
      }
    }
    setTimeout(() => {
      setReloadBaseList(false);
    }, 0);
  };

  /**
   * Identify the use of unique items when adding or removing items
   */
  const uniqueItemWatchman = () => {
    //list of unique items
    let availableItems = {
      absences: true,
      groupAverage: true,
    };

    for (let property in availableItems) {
      if (listFormatItems.find((item) => item.type == property)) {
        availableItems[property] = false;
      }
    }
    setUniqueItems(availableItems);
  };

  /**
   * counts the subjects on the list TODO: Remove if integration of formative fields is completed
   */
  // const subjectCounter = (list) => {
  //   let count = list.filter((item) => item.type === "subject" || item.type === "developmentArea").length;
  //   setNumberOfSubjects(count);
  // };

  /**
   * Renders the per-period grade cells for one column. `valueFor(cell)` decides
   * what each cell shows: defaults to 0 (the grade rows); the PROMEDIO row passes
   * a predicate so only the average-type cells (cf1/cf2/avg) are filled. Mirrors
   * the active header layout (no partials / partials / Por Parciales), so any row
   * built with it stays aligned with the header.
   * @param {number} indexColumn column index (3 = global average column)
   * @param {(cell: string) => any} valueFor value shown per cell
   */
  const renderPeriodGrades = (indexColumn, valueFor = () => 0) => {
    if (!showPartialGrades || indexColumn == 3) return 0;
    if (!showCFPartialAvg) {
      const cells = ["p1", "p2", "avg"];
      return (
        <Row style={{ width: "100%" }}>
          {cells.map((cell) => (
            <Col key={cell} sm={4} md={4} lg={4} xl={4} className="text-center">
              {valueFor(cell)}
            </Col>
          ))}
        </Row>
      );
    }
    const cfCells = ["p1", "cf1", "p2", "cf2", "avg"];
    return (
      <Row style={{ width: "100%" }} className="g-0 flex-nowrap">
        {cfCells.map((cell) => (
          <Col key={cell} className="p-0 text-center">
            {valueFor(cell)}
          </Col>
        ))}
      </Row>
    );
  };

  /**
   * generates rows of ratings according to element type
   * @param {*} type
   */
  const generateRow = (item, index) => {
    let customLine = <Row key={index}></Row>;
    const columns = [1, 2, 3, 4];
    switch (item.type) {
      case "subject":
        customLine = (
          <Row key={index} style={{ height: "84px" }}>
            {columns.map((v, indexColumn) => {
              return (
                <Col
                  md={3}
                  key={v}
                  style={{
                    overflow: " hidden",
                    paddingLeft: "0px",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {renderPeriodGrades(indexColumn)}
                </Col>
              );
            })}
          </Row>
        );
        break;
      case "blankLine":
        customLine = (
          <Row key={index} style={{ height: "43px" }}>
            {columns.map((v) => {
              return (
                <Col
                  md={3}
                  key={v}
                  style={{
                    textAlign: "center",
                    paddingTop: "5px",
                  }}
                ></Col>
              );
            })}
          </Row>
        );
        break;
      case "dottedLine":
        customLine = (
          <Row key={index} style={{ height: "43px" }}>
            {columns.map((v) => {
              return (
                <Col
                  md={3}
                  key={v}
                  style={{
                    textAlign: "center",
                    paddingTop: "5px",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                >
                  <div
                    style={{ borderTop: "dashed 1px black", marginTop: "14px" }}
                  ></div>
                </Col>
              );
            })}
          </Row>
        );
        break;
      case "average":
        customLine = (
          <Row key={index} style={{ height: "72px" }}>
            {columns.map((v) => {
              return (
                <Col
                  md={3}
                  key={v}
                  style={{
                    overflow: " hidden",
                    paddingLeft: "0px",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  0
                </Col>
              );
            })}
          </Row>
        );
        break;
      case "absences":
        customLine = (
          <Row key={index} style={{ height: "43px" }}>
            {columns.map((v) => {
              return (
                <Col
                  md={3}
                  key={v}
                  style={{
                    textAlign: "center",
                    paddingTop: "5px",
                    overflow: "hidden",
                    paddingLeft: "0px",
                  }}
                >
                  <p>0</p>
                </Col>
              );
            })}
          </Row>
        );
        break;
      case "developmentArea": {
        const developmentAreaClasses = item.classes || item.subjects || [];
        const partialAveragesFF = isFeatureEnabled(
          "partial_averages_in_development_areas"
        );
        const blockHeight = developmentAreaClasses.length * 64;
        // One "0" per class — for the raw partial cells (p1, p2) that exist at
        // class level.
        const perClassCells = (keyName) => (
          <Col key={keyName} className="p-0 text-center">
            {developmentAreaClasses.map((singleClass, classIndex) => (
              <div
                key={classIndex}
                style={{
                  height: "64px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                0
              </div>
            ))}
          </Col>
        );
        // A single "0" vertically centered across the whole CF block — for the
        // CF-aggregate cells (cf1, cf2, period avg and the global average).
        const centeredCell = (keyName, asCol = true) => {
          const content = (
            <div
              style={{
                height: blockHeight + "px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              0
            </div>
          );
          return asCol ? (
            <Col key={keyName} className="p-0 text-center">
              {content}
            </Col>
          ) : (
            content
          );
        };
        // Builds the content of one period/average column for the CF.
        const renderDevelopmentAreaCell = (indexColumn) => {
          // FF off → keep the original single-render behavior (no regression).
          if (!partialAveragesFF) return renderPeriodGrades(indexColumn);
          // Global average column → one centered "0" per CF.
          if (indexColumn == 3) return centeredCell("avgGlobal", false);
          // "Por Parciales" → p1/p2 per class; cf1/cf2/avg are CF-level, so a
          // single "0" centered across the block.
          if (showCFPartialAvg) {
            return (
              <Row
                style={{ width: "100%", height: blockHeight + "px" }}
                className="g-0 flex-nowrap"
              >
                {perClassCells("p1")}
                {centeredCell("cf1")}
                {perClassCells("p2")}
                {centeredCell("cf2")}
                {centeredCell("avg")}
              </Row>
            );
          }
          // "Mostrar parciales" (without "Por Parciales") → p1/p2 stay per
          // class, but the period "Pro" is a CF-level aggregate when grouping
          // by development areas, so it collapses to a single "0" centered
          // across the whole CF block (mirrors the "Por Parciales" layout).
          if (showPartialGrades) {
            return (
              <Row
                style={{ width: "100%", height: blockHeight + "px" }}
                className="g-0 flex-nowrap"
              >
                {perClassCells("p1")}
                {perClassCells("p2")}
                {centeredCell("cfPeriodAvg-" + indexColumn)}
              </Row>
            );
          }
          // Only "Promediar Campos" → grade per class + the CF period-level
          // average as a single "0" centered across the CF block.
          return (
            <Row
              style={{ width: "100%", height: blockHeight + "px" }}
              className="g-0 flex-nowrap"
            >
              <Col className="p-0 text-center">
                {developmentAreaClasses.map((singleClass, classIndex) => (
                  <div
                    key={classIndex}
                    style={{
                      height: "64px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {renderPeriodGrades(indexColumn)}
                  </div>
                ))}
              </Col>
              {centeredCell("cfPeriodAvg-" + indexColumn)}
            </Row>
          );
        };
        customLine = (
          <Row
            key={index}
            style={{
              height: blockHeight + "px",
              // Match the editor column's per-field footprint that this column
              // lacks: mb-3 gap (16px) + the CF box chrome (p-1 8px + border 2px)
              // = 26px. Keeps both columns in the same vertical rhythm. Gated by
              // the FF so the view is untouched when it is off.
              marginBottom: partialAveragesFF ? "26px" : 0,
            }}
          >
            {columns.map((v, indexColumn) => (
              <Col
                md={3}
                key={v}
                style={{
                  textAlign: "center",
                  paddingTop: "5px",
                  overflow: "hidden",
                  paddingLeft: "0px",
                }}
              >
                {renderDevelopmentAreaCell(indexColumn)}
              </Col>
            ))}
          </Row>
        );
        break;
      }
      case "groupAverage":
        customLine = (
          <Row key={index} style={{ height: "50px" }}>
            {columns.map((v) => {
              return (
                <Col
                  md={3}
                  key={v}
                  style={{
                    textAlign: "center",
                    paddingTop: "5px",
                    overflow: "hidden",
                    paddingLeft: "0px",
                  }}
                >
                  0
                </Col>
              );
            })}
          </Row>
        );
        break;
      case "main_subject":
        customLine = (
          <Row key={index} style={{ height: "84px" }}>
            {columns.map((v, indexColumn) => {
              return (
                <Col
                  md={3}
                  key={v}
                  style={{
                    overflow: " hidden",
                    paddingLeft: "0px",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {renderPeriodGrades(indexColumn)}
                </Col>
              );
            })}
          </Row>
        );
        break;
      default:
    }
    return customLine;
  };

  /**
   * Renders the bottom "PROMEDIO" row (Total Average by Period), shown when the
   * showCFPeriodAvg sub-switch is active. Reuses renderPeriodGrades so it always
   * matches the active period/partials layout: only the average-type cells
   * (cf1, cf2, avg) are filled with 0 and the raw partial cells stay blank. The
   * CF-per-partial cells (cf1, cf2) only exist when "Por Parciales" is on.
   */
  const renderPeriodTotalAverageRow = () => {
    const columns = [1, 2, 3, 4];
    const periodAvgValue = (cell) =>
      ["cf1", "cf2", "avg"].includes(cell) ? 0 : "";
    return (
      <Row style={{ height: "50px" }}>
        {columns.map((v, indexColumn) => (
          <Col
            md={3}
            key={v}
            style={{
              overflow: "hidden",
              paddingLeft: "0px",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            {renderPeriodGrades(indexColumn, periodAvgValue)}
          </Col>
        ))}
      </Row>
    );
  };

  /**
   * empty all selected classes in items
   */
  const cleanSelectedClasses = () => {
    let items = [...listFormatItems];
    // Ungroup the development areas
    items = ungroupDevelopmentAreas(items);

    items.forEach((item) => {
      if (item.type === "subject") {
        delete item.value;
        delete item.values;
      }
    });
    setListFormatItems(items);
  };

  /**
   * empty all selected subjects in items
   */
  const cleanSelectedSubjects = () => {
    let items = [...listFormatItems];
    items.forEach((item) => {
      if (item.type === "main_subject") {
        delete item.value;
        delete item.values;
      }
    });
    setListFormatItems(items);
  };

  /**
   * Puporse: Group or ungroup the classes by development area
   */
  /**
   * CM-52604: resolve a class's current Campo Formativo from the loaded class
   * catalog (getClass fills backupDefaulsClasses/defaulsClasses with each class's
   * development_area). Grouping/saving uses this as a fallback so a stale format
   * with developmentAreaID=null still groups by the class's real CF instead of
   * silently flattening. Returns {id, name} (null when the class has no CF).
   */
  const resolveClassDevArea = (classId) => {
    const source = backupDefaulsClasses?.length
      ? backupDefaulsClasses
      : defaulsClasses;
    for (const group of source || []) {
      for (const option of group?.options || []) {
        if (String(option.value) === String(classId)) {
          return {
            id: option.developmentAreaID || null,
            name: option.developmentAreaName || null,
          };
        }
      }
    }
    return { id: null, name: null };
  };

  const groupByDevelopmentField = () => {
    setReloadBaseList(true);
    let items = [...listFormatItems];
    // CM-52604: track whether turning the switch ON actually formed any group,
    // so we don't flip the toggle (and let the CF sub-switches be enabled) over
    // a still-flat format.
    let groupsFormed = false;
    // Filter the items for the development area
    if (!groupedByDevelopmentAreas) {
      // Add a parameter with its position to each item
      for (let i = 0; i < items.length; i++) {
        items[i].positionInList = i;
      }
      let newsDevelopmentAreas = [];
      for (const element of items) {
        if (element.type != "subject") {
          continue;
        }
        // CM-52604: resolve the CF with a robust fallback (`.value` → `.values`
        // → current class catalog) so a stale format (developmentAreaID null)
        // still groups by the class's real CF instead of staying flat.
        const classId =
          (element.value && element.value.value) ??
          (element.values && element.values.id);
        let devAreaID =
          (element.value && element.value.developmentAreaID) ||
          (element.values && element.values.developmentAreaID) ||
          null;
        let devAreaName =
          (element.value && element.value.developmentAreaName) ||
          (element.values && element.values.developmentAreaName) ||
          null;
        if (!devAreaID) {
          const resolved = resolveClassDevArea(classId);
          devAreaID = resolved.id;
          devAreaName = resolved.name;
        }
        // Class genuinely has no CF (e.g. FUTBOL) → leave it as a flat subject.
        if (!devAreaID) {
          continue;
        }
        // Keep `.value` in sync so the save serializer and a later ungroup
        // preserve the CF link.
        if (element.value) {
          element.value.developmentAreaID = devAreaID;
          element.value.developmentAreaName = devAreaName;
        }
        let existGroup = newsDevelopmentAreas.find(
          (group) => group.development_area_id == devAreaID
        );
        if (existGroup) {
          existGroup.classes.push(element);
        } else {
          // Create a new development area group
          newsDevelopmentAreas.push({
            id: "8",
            development_area_id: devAreaID,
            positionInList: element.positionInList,
            type: "developmentArea",
            title: devAreaName,
            disabled: false,
            averaging: true,
            classes: [element],
          });
        }
      }
      groupsFormed = newsDevelopmentAreas.length > 0;
      let classesForDelete = [];
      // Insert groups in the main list
      for (const key in newsDevelopmentAreas) {
        let position =
          key == 0
            ? newsDevelopmentAreas[key].positionInList
            : newsDevelopmentAreas[key].positionInList + 1;
        items.splice(position, 0, newsDevelopmentAreas[key]);
        classesForDelete = classesForDelete.concat(
          newsDevelopmentAreas[key].classes
        );
      }
      // Deleting grouped items from the main list
      for (const elementClass of classesForDelete) {
        for (let key = items.length - 1; key >= 0; key--) {
          if (
            items[key].type == "subject" &&
            items[key].value &&
            items[key].value.value == elementClass.value.value
          ) {
            items.splice(key, 1);
          }
        }
      }
    }
    // Ungroup the development areas
    else {
      items = ungroupDevelopmentAreas(items);
    }
    setListFormatItems(items);
    // CM-52604: only turn the switch ON if grouping actually produced groups;
    // otherwise keep it OFF so the CF sub-switches can't be enabled/saved over a
    // flat format. Turning OFF (ungroup) always sets it false.
    setGroupedByDevelopmentAreas(
      groupedByDevelopmentAreas ? false : groupsFormed
    );
    // "Por Parciales" depends on "Promediar Campos Formativos": turning it off turns this off too.
    if (
      groupedByDevelopmentAreas &&
      isFeatureEnabled("partial_averages_in_development_areas")
    ) {
      setShowCFPartialAvg(false);
      setShowCFPeriodAvg(false);
      setShowCFWeights(false);
      setCFWeights({});
      setTemplateInformation({
        ...templateInformation,
        show_cf_partial_avg: 0,
        show_cf_period_avg: 0,
        show_cf_weights: 0,
      });
    }
    setTimeout(() => {
      setReloadBaseList(false);
    }, 0);
  };

  /**
   * Purpose: Ungroup the development areas
   * @param {array} items
   * @returns array
   */
  const ungroupDevelopmentAreas = (items) => {
    // Extract all classes from the development group elements and add them to the list
    let ungroupingClasses = [];
    for (const key in items) {
      if (items[key].type == "developmentArea") {
        ungroupingClasses.push({
          position: key,
          classes: items[key].classes,
        });
      }
    }
    for (let i = ungroupingClasses.length - 1; i >= 0; i--) {
      let position = ungroupingClasses[i].position;
      items.splice(position, 1, ...ungroupingClasses[i].classes);
    }
    return items;
  };

  /**
   * Effect when adding single items
   */
  useEffect(() => {
    uniqueItemWatchman();
  }, [listFormatItems.length]);

  useEffect(() => {
    const valores = window.location.search;
    const urlParams = new URLSearchParams(valores);
    if (
      (templateInformation.id || urlParams.get("group")) &&
      schoolCycles.length
    ) {
      //find the cycle, level, grade and group
      let cycleSelect = { ...cycleSelected };
      for (let cycle of schoolCycles) {
        for (let level of cycle.schoolLevels) {
          for (let grade of level.grades) {
            for (let group of grade.groups) {
              const gg_gl_id = templateInformation.id
                ? templateInformation.gradeGroupGradeLevelId
                : urlParams.get("group");
              if (group.grade_group_grade_level_id == gg_gl_id) {
                cycleSelect = cycle;
                cycleSelect.schoolLevels = cycle.schoolLevels;
                cycleSelect.grades = level.grades;
                cycleSelect.groups = grade.groups;

                cycleSelect.levelSelected = level.id;
                cycleSelect.gradeSelected = grade.id;
                cycleSelect.groupSelected = group.id;

                cycleSelect.gradeName = grade.grade_level;
                cycleSelect.groupName = group.name;
                setHasDevelopmentAreas(!!(level.has_development_areas == 1));
                cycleSelect.hasDevelopmentAreas =
                  level.has_development_areas == 1;
                setCycleSelected(cycleSelect);
                if (urlParams.get("group")) {
                  let newFilter = {
                    type: "gradeGroupLevelId",
                    value: urlParams.get("group"),
                  };
                  getClass("", false, newFilter, false);
                  getSubjects("", false, newFilter, false); //FIXME: cachar y aplciar filtros
                  let template = templateInformation;
                  template.gradeGroupGradeLevelId = urlParams.get("group");
                  setTemplateInformation(template);
                  setClassFilter(newFilter);
                }
                break;
              }
            }
          }
        }
      }
    }
  }, [schoolCycles.length]);

  /**
   * initial effect of a single load
   */
  useEffect(() => {
    Sentry.setTag("section", "Report Card Profile");
    const templateId = props.match.params.id;
    if (templateId != "new") {
      setAvailableAllocationValues(true);
      setTemplateId(templateId);
      getTemplate(templateId);
    }
    getOrganization();
    getCurrentCycle();
  }, []);

  useEffect(() => {
    refreshAvailableClassList(listFormatItems, defaulsClasses);
  }, [defaulsClasses, listFormatItems]);

  useEffect(() => {
    refreshAvailableSubjectList(listFormatItems, defaulsSubjects);
  }, [defaulsSubjects, listFormatItems]);

  /**
   * Purpose: Redirect to cycle configuration section
   * @param {String} tabView
   */
  const goApp1 = (tabView) => {
    var now = new Date();
    now.setDate(now.getDate() + 5);
    goToHref(`/configuraciones/${tabView}`);
  };

  const printError = (message) => {
    setError({
      active: true,
      message,
    });
    setTimeout(() => {
      setError({
        active: false,
        message: "",
      });
    }, 3500);
  };

  const periodsHeader = () => {
    return (
      <>
        <Col
          md={groupedByDevelopmentAreas ? { span: 8 } : { span: 8, offset: 4 }}
          xxl={groupedByDevelopmentAreas ? { span: 9 } : { span: 9, offset: 3 }}
        >
          <Row style={{ border: "1px solid #dee2e6 " }}>
            {[1, 2, 3, t("reportCards:page.average")].map((item, index) => {
              return (
                <Col
                  key={index}
                  md={3}
                  className="p-1 text-center"
                  style={{
                    borderRight: "1px solid #dee2e6",
                  }}
                >
                  {index == 3
                    ? item
                    : t("reportCards:page.period") + " " + item}
                </Col>
              );
            })}
          </Row>
        </Col>
        <Col
          md={{ span: 8, offset: 4 }}
          xxl={{ span: 9, offset: 3 }}
          style={{
            borderBottom: "1px solid #dee2e6",
            borderLeft: "1px solid #dee2e6",
            borderRight: "1px solid #dee2e6",
          }}
        >
          <Row>
            {[1, 2, 3, "N"].map((item) => {
              return (
                <Col
                  key={item}
                  md={3}
                  className="p-1 text-center"
                  style={{ borderRight: " 1px solid #dee2e6 " }}
                >
                  {t("reportCards:page.rating")}
                </Col>
              );
            })}
          </Row>
        </Col>
      </>
    );
  };

  const periodsAndPartialsHeader = () => {
    return (
      <>
        <Col
          md={groupedByDevelopmentAreas ? { span: 8 } : { span: 8, offset: 4 }}
          xxl={groupedByDevelopmentAreas ? { span: 9 } : { span: 9, offset: 3 }}
        >
          <Row style={{ border: "1px solid #dee2e6 " }}>
            {[1, 2, 3, t("reportCards:page.average")].map((item, index) => {
              return (
                <Col
                  key={index}
                  md={3}
                  className="text-center"
                  style={{
                    borderRight: "1px solid #dee2e6",
                  }}
                >
                  <Row>
                    <Col>
                      {index == 3
                        ? item
                        : t("reportCards:page.period") + " " + item}
                    </Col>
                  </Row>
                  {index < 3 &&
                    (showCFPartialAvg ? (
                      <Row style={{ width: "100%" }} className="g-0 flex-nowrap">
                        {/* CF average columns ("cf") render with no title/tooltip */}
                        {[1, "cf", 2, "cf", "avg"].map((cell, indexPartial) => {
                          return (
                            <Col
                              key={indexPartial}
                              id={"partial-" + index + "-" + indexPartial}
                              className="p-0 text-center"
                            >
                              {cell === "avg"
                                ? t("reportCards:page.abridgedAverage")
                                : cell === "cf"
                                ? ""
                                : cell}
                            </Col>
                          );
                        })}
                      </Row>
                    ) : (
                      <Row>
                        {[1, 2, "avg"].map((partial, indexPartial) => {
                          return (
                            <Col
                              key={partial}
                              id={"partial-" + index + "-" + indexPartial}
                              md={4}
                              className="p-0 text-center"
                            >
                              {indexPartial == 2
                                ? t("reportCards:page.abridgedAverage")
                                : partial}
                            </Col>
                          );
                        })}
                      </Row>
                    ))}
                </Col>
              );
            })}
          </Row>
        </Col>
        <Col
          md={{ span: 8, offset: 4 }}
          xxl={{ span: 9, offset: 3 }}
          style={{
            height: "20px",
            borderBottom: "1px solid #dee2e6",
            borderLeft: "1px solid #dee2e6",
            borderRight: "1px solid #dee2e6",
          }}
        >
          <Row style={{ height: "20px" }}>
            {[1, 2, 3, "N"].map((item) => {
              return (
                <Col
                  key={item}
                  md={3}
                  className="p-1 text-center"
                  style={{ borderRight: " 1px solid #dee2e6 " }}
                ></Col>
              );
            })}
          </Row>
        </Col>
      </>
    );
  };

  return (
    <div>
      <Container fluid>
        <Breadcrumb style={{ "--bs-breadcrumb-divider": "'>'" }}>
          <Breadcrumb.Item
            id="breadcrumbConfig"
            style={{ color: "#bfc2c6" }}
            onClick={() => goApp1("ciclo")}
          >
            <i
              style={{ color: "#bfc2c6", fontSize: "15px", marginRight: "5px" }}
              className="bi bi-gear"
            ></i>
            {t("reportCards:page.configuration")}
          </Breadcrumb.Item>
          <Breadcrumb.Item active style={{ color: "#bfc2c6" }}>
            {t("reportCards:page.title")}
          </Breadcrumb.Item>
        </Breadcrumb>
        <h2>{t("reportCards:page.title")}</h2>
        {/* button panel */}
        <Row>
          <Col sm={3} md={3} xl={3} xxl={2}>
            <h6 className="fw-bold">
              <div
                id="backToReportCardsButton"
                style={{ cursor: "pointer", width: "fit-content" }}
                onClick={() => {
                  if (Cookies.get(`sourceList${prefix}`)) {
                    let domain = window.location.href.includes(
                      ".campusmovil.com"
                    )
                      ? ".campusmovil.com"
                      : window.location.hostname;
                    Cookies.remove(`sourceList${prefix}`, {
                      domain: domain,
                      path: "/",
                    });

                    history.push("/settings/report_cards");
                  } else {
                    goApp1("ciclo");
                  }
                }}
              >
                <i className="bi bi-chevron-left"></i>

                {t("reportCards:page.back")}
              </div>
            </h6>
          </Col>
          <Col sm={3} md={3} xl={4} xxl={4} style={{ color: "#6c757d" }}>
            {isEditing ? (
              <Formik initialValues={templateInformation}>
                {(values) => (
                  <Row>
                    <Col lg={12}>
                      <FieldInput
                        id="templateNameInput"
                        name="name"
                        type="text"
                        label={false}
                        placeholder=""
                        onBlur={() => {
                          templateInformation.name = values.values.name;
                          setTemplateInformation(templateInformation);
                          setIsEditing(!isEditing);
                        }}
                      />
                    </Col>
                  </Row>
                )}
              </Formik>
            ) : (
              <Row>
                <Col
                  md={12}
                  id="templateNameDisplay"
                  onClick={() => setIsEditing(!isEditing)}
                >
                  {templateInformation.name}
                </Col>
              </Row>
            )}
          </Col>
          <Col sm={3} md={3} xl={3} xxl={4} style={{ color: "#6c757d" }}>
            <Button
              id="saveTemplateButton"
              variant="primary"
              className="float-end fw-bold"
              onClick={() => setShowSaveChanges(true)}
              disabled={
                templateInformation.name == "" ||
                !listFormatItems.length ||
                !templateInformation.gradeGroupGradeLevelId ||
                loadingCFWeights
              }
            >
              {templateId
                ? t("reportCards:page.saveChanges")
                : t("reportCards:page.save")}
            </Button>
            {showObservations && (
              <div
                id="togglePageButton"
                className="me-3"
                style={{ float: "right", cursor: "pointer" }}
                onClick={() => setVisiblePage(visiblePage == 1 ? 2 : 1)}
              >
                {visiblePage == 2 && <i className="bi bi-chevron-left"></i>}
                <p className="d-inline fw-bold text-dark ">
                  {visiblePage == 2
                    ? t("reportCards:page.page1")
                    : t("reportCards:page.page2")}
                </p>
                {visiblePage == 1 && <i className="bi bi-chevron-right"></i>}
              </div>
            )}
          </Col>
          <Col sm={3} md={3} xl={2} xxl={2}></Col>
        </Row>
        {/* body */}
        <Row>
          {/* Assignment Details */}
          <Col sm={3} md={3} xl={3} xxl={2} style={customStyles.columnBase}>
            <AssignmentDetails
              schoolCycles={schoolCycles}
              cycleSelected={cycleSelected}
              setCycleSelected={setCycleSelected}
              showObservations={showObservations}
              setShowObservations={setShowObservations}
              setVisiblePage={setVisiblePage}
              availableAllocationValues={availableAllocationValues}
              templateInformation={templateInformation}
              setTemplateInformation={setTemplateInformation}
              classFilter={classFilter}
              getClass={getClass}
              getSubjects={getSubjects}
              setDefaulsClasses={setDefaulsClasses}
              cleanSelectedClasses={cleanSelectedClasses}
              setClassFilter={setClassFilter}
              hasDevelopmentAreas={hasDevelopmentAreas}
              groupedByDevelopmentAreas={groupedByDevelopmentAreas}
              groupByDevelopmentField={groupByDevelopmentField}
              setHasDevelopmentAreas={setHasDevelopmentAreas}
              activeAveragingSelectionMode={activeAveragingSelectionMode}
              cleanSelectedSubjects={cleanSelectedSubjects}
              setDefaulsSubjects={setDefaulsSubjects}
              showPartialGrades={showPartialGrades}
              setShowPartialGrades={setShowPartialGrades}
              showCFPartialAvg={showCFPartialAvg}
              setShowCFPartialAvg={setShowCFPartialAvg}
              showCFPeriodAvg={showCFPeriodAvg}
              setShowCFPeriodAvg={setShowCFPeriodAvg}
              showCFWeights={showCFWeights}
              setShowCFWeights={handleShowCFWeightsChange}
              openCFWeightsModal={() => setShowCFWeightsModal(true)}
              onEnableCFWeights={() =>
                loadAllCFWeights(templateInformation.id)
              }
            />
          </Col>
          {/* Editing area */}
          <Col sm={6} md={6} xl={7} xxl={8} style={customStyles.columnBase}>
            <Row style={customStyles.solidBackground}>
              {/* displays warnings if any */}
              {error.active && (
                <Col md={12}>
                  <Alert key={1} variant={"warning"}>
                    {error.message}
                  </Alert>
                </Col>
              )}
              <Col md={12} id="templateContainer">
                {/* general data */}
                <Row className="mb-4">
                  <Col md={2} style={{ textAlign: "center" }}>
                    <img
                      src={organizationInfo.logoUrl}
                      className="img-fluid"
                      style={{ maxHeight: "100px" }}
                      alt=""
                      id="logo"
                    />
                  </Col>
                  <Col md={10}>
                    <Row>
                      <Col md={5}>
                        <Col md={12}>
                          <h5 className="fw-bold">{organizationInfo.name}</h5>
                        </Col>
                        <Col md={12}>{t("reportCards:page.studentName")}</Col>
                      </Col>
                      <Col md={7} className="fw-bold">
                        <Row>
                          <Col md={4}>{t("reportCards:page.cycle")}</Col>
                          <Col md={4}>{t("reportCards:page.grade")}</Col>
                          <Col md={4}>{t("reportCards:page.group")}</Col>
                        </Row>
                        <Row>
                          <Col md={4}>{cycleSelected.name}</Col>
                          <Col md={4}>{cycleSelected.gradeName || "-"}</Col>
                          <Col md={4}>{cycleSelected.groupName || "-"}</Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {/* pagina 1 */}
                {visiblePage == 1 && (
                  <div>
                    {/* periods */}
                    <Row className="mb-4">
                      {groupedByDevelopmentAreas && (
                        <Col md={4} xxl={3}>
                          <Row
                            className="border-bottom"
                            style={
                              showPartialGrades
                                ? { height: "39px" }
                                : { height: "29px" }
                            }
                          >
                            <Col md={12} className="p-1 text-center">
                              {t("reportCards:page.developmentAreas")}
                            </Col>
                          </Row>
                        </Col>
                      )}
                      {showPartialGrades
                        ? periodsAndPartialsHeader()
                        : periodsHeader()}
                    </Row>
                    <Row>
                      {/* item drop zone */}
                      <Col md={4} xxl={3} style={{ minHeight: "500px" }}>
                        {reloadBaseList ? null : (
                          <ReactSortable
                            id="sortableList"
                            list={listFormatItems}
                            setList={(list) => {
                              updateFormatList(list);
                              // subjectCounter(list);
                            }}
                            group={{ name: "options" }}
                            animation={200}
                            delay={150}
                            // CM-52604 (QA): with delayOnTouchOnly=false the
                            // 150ms hold also applied to mouse drags, forcing
                            // the user to keep the click pressed for an
                            // instant before the item was "grabbed". The
                            // handle (".bi-list") already prevents accidental
                            // drags from a stray click, so the delay is only
                            // needed to distinguish a tap/scroll from a drag
                            // on touch devices.
                            delayOnTouchOnly={true}
                            removeOnSpill={true}
                            onEnd={(evt) => deleteItem(evt)}
                            handle=".bi-list"
                            style={customStyles.dropZone}
                            sort={lockItemSorting}
                          >
                            {/* Children built as a filtered array so no falsy child
                                (false/null) ever reaches ReactSortable.getChildren,
                                which dereferences child.props without a null guard. */}
                            {[
                              ...listFormatItems.map((item, index) => (
                                <ReportCardItemCreator
                                  key={index}
                                  item={item}
                                  position={index}
                                  getOptions={getClass}
                                  defaulsOptions={defaulsClasses}
                                  selectClass={selectClass}
                                  editAveragingFormat={editAveragingFormat}
                                  setshowSettingAveraging={
                                    setshowSettingAveraging
                                  }
                                  changeClassesSelectionMode={
                                    changeClassesSelectionMode
                                  }
                                  selectClassesForAveraging={
                                    selectClassesForAveraging
                                  }
                                  removeItemByButton={removeItemByButton}
                                  updateFormatList={updateFormatList}
                                  listFormatItems={listFormatItems}
                                  refreshAvailableClassList={
                                    refreshAvailableClassList
                                  }
                                  getSubjects={getSubjects}
                                  defaulsSubjects={defaulsSubjects}
                                  selectSubjects={selectSubjects}
                                  refreshAvailableSubjectList={
                                    refreshAvailableSubjectList
                                  }
                                  cfWeights={cfWeights}
                                  showCFWeights={showCFWeights}
                                  requestDeleteWeightedClass={
                                    requestDeleteWeightedClass
                                  }
                                  requestAddClassToWeightedCF={
                                    requestAddClassToWeightedCF
                                  }
                                />
                              )),
                              // Static "PROMEDIO" label as the last child of the
                              // sortable: sibling of the development areas, with no
                              // .bi-list handle so it cannot be dragged, and kept out
                              // of listFormatItems (never saved). Mirrors the
                              // groupAverage item markup to align with its values row.
                              isFeatureEnabled(
                                "partial_averages_in_development_areas"
                              ) &&
                                showCFPeriodAvg && (
                                  <Col
                                    key="cfPeriodAvgLabel"
                                    md={12}
                                    style={{
                                      border: "solid 1px #cccccc",
                                      borderRadius: "8px",
                                      textTransform: "uppercase",
                                      height: "50px",
                                    }}
                                    className="mb-3 p-1 d-flex align-items-center"
                                  >
                                    {t("reportCards:page.average")}
                                  </Col>
                                ),
                            ].filter(Boolean)}
                          </ReactSortable>
                        )}
                      </Col>
                      <Col md={8} xxl={9} style={{ marginTop: "5px" }}>
                        {listFormatItems.map((item, index) => {
                          return (
                            item.type != "phantomElement" &&
                            generateRow(item, index)
                          );
                        })}
                        {/* "PROMEDIO" values row (Total Average by Period), sibling of
                            the development-area rows. */}
                        {isFeatureEnabled(
                          "partial_averages_in_development_areas"
                        ) &&
                          showCFPeriodAvg &&
                          renderPeriodTotalAverageRow()}
                      </Col>
                    </Row>
                  </div>
                )}
                {/* comment view */}
                {visiblePage == 2 && (
                  <div>
                    {/* pagina 2 */}
                    <Row>
                      <Col md={{ span: 9, offset: 3 }}>
                        <Row>
                          <Col md={3}>{t("reportCards:page.period")} 1</Col>
                          <Col md={3}>{t("reportCards:page.period")} 2</Col>
                          <Col md={3}>{t("reportCards:page.period")} 3</Col>
                          <Col md={3}>{t("reportCards:page.period")} 4</Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={3} style={{ marginTop: "29px" }}>
                        {reloadBaseList ? null : (
                          <ReactSortable
                            list={listFormatItems}
                            setList={(list) => {
                              updateFormatList(list);
                              //  subjectCounter(list);
                            }}
                            group={{ name: "options" }}
                            animation={200}
                            delay={150}
                            // CM-52604 (QA): see the sibling ReactSortable
                            // above — delayOnTouchOnly=false was making the
                            // 150ms hold apply to mouse drags too.
                            delayOnTouchOnly={true}
                            removeOnSpill={true}
                            onEnd={(evt) => deleteItem(evt)}
                            handle=".bi-list"
                            style={customStyles.dropZone}
                            sort={lockItemSorting}
                          >
                            {listFormatItems.map((item, index) => (
                              <ReportCardItemCreator
                                key={index}
                                item={item}
                                position={index}
                                getOptions={getClass}
                                defaulsOptions={defaulsClasses}
                                selectClass={selectClass}
                                editAveragingFormat={editAveragingFormat}
                                setshowSettingAveraging={
                                  setshowSettingAveraging
                                }
                                changeClassesSelectionMode={
                                  changeClassesSelectionMode
                                }
                                selectClassesForAveraging={
                                  selectClassesForAveraging
                                }
                                removeItemByButton={removeItemByButton}
                                commentView={true}
                                updateFormatList={updateFormatList}
                                listFormatItems={listFormatItems}
                                refreshAvailableClassList={
                                  refreshAvailableClassList
                                }
                              />
                            ))}
                          </ReactSortable>
                        )}
                      </Col>
                      <Col md={9}>
                        <Row>
                          {[1, 2, 3].map((v) => {
                            return (
                              <Col
                                key={v}
                                md={3}
                                style={{
                                  borderRight: "solid 1px black",
                                  marginTop: "29px",
                                }}
                              >
                                {listFormatItems
                                  .filter(
                                    (item) =>
                                      item.type === "subject" ||
                                      item.type === "developmentArea"
                                  )
                                  .map((item, index) => {
                                    item.classes =
                                      item.classes || item.subjects;
                                    const height =
                                      item.type === "developmentArea"
                                        ? item.classes.length * 65 + "px"
                                        : "65px";
                                    return (
                                      <Row
                                        key={index}
                                        style={{
                                          height: height,
                                          borderBottom: "solid 1px black",
                                        }}
                                      >
                                        <p>
                                          {t(
                                            "reportCards:page.teachersComments"
                                          )}
                                        </p>
                                      </Row>
                                    );
                                  })}
                              </Col>
                            );
                          })}

                          <Col
                            key={0}
                            md={3}
                            style={{
                              marginTop: "29px",
                            }}
                          >
                            {listFormatItems
                              .filter(
                                (item) =>
                                  item.type === "subject" ||
                                  item.type === "developmentArea"
                              )
                              .map((item, index) => {
                                const height =
                                  item.type === "developmentArea"
                                    ? item.classes.length * 65 + "px"
                                    : "65px";
                                return (
                                  <Row
                                    key={index}
                                    style={{
                                      height: height,
                                      borderBottom: "solid 1px black",
                                    }}
                                  >
                                    <p>
                                      {t("reportCards:page.teachersComments")}
                                    </p>
                                  </Row>
                                );
                              })}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                )}
              </Col>
            </Row>
          </Col>
          {/* selectable elements  */}
          <Col sm={3} md={3} xl={2} xxl={2} style={customStyles.columnBase}>
            <DraggableElements uniqueItems={uniqueItems} />
          </Col>
        </Row>
      </Container>

      {/* modales */}
      <NewTamplateModal
        showNewTamplateModal={showNewTamplateModal}
        setShowNewTamplateModal={setShowNewTamplateModal}
        setNewTemplate={setTemplateInformation}
        setListFormatItems={setListFormatItems}
      />
      <SaveChangesModal
        showSaveChanges={showSaveChanges}
        setShowSaveChanges={setShowSaveChanges}
        saveTemplate={saveTemplate}
        templateName={templateInformation.name}
        saving={saving}
      />
      <SettingAveragingFormatModal
        showSettingAveraging={showSettingAveraging}
        setshowSettingAveraging={setshowSettingAveraging}
        editingGradingFormat={editingGradingFormat}
        saveAverageformat={saveAverageformat}
        changeClassesSelectionMode={changeClassesSelectionMode}
      />
      <ConfirmDeleteModal
        showConfirmDeleteModal={showConfirmDeleteModal}
        setShowConfirmDeleteModal={setShowConfirmDeleteModal}
        templateToDelete={templateToDelete}
        templateInformation={templateInformation}
        setTemplateInformation={setTemplateInformation}
        setListFormatItems={setListFormatItems}
        getTemplates={getTemplates}
      />
      {isFeatureEnabled("partial_averages_in_development_areas") && (
        <CFWeightsModal
          show={showCFWeightsModal}
          setShow={setShowCFWeightsModal}
          developmentAreas={listFormatItems.filter(
            (item) => item.type === "developmentArea"
          )}
          cfWeights={cfWeights}
          onSaveCF={onSaveCFWeights}
          templateId={templateInformation.id}
        />
      )}
      {isFeatureEnabled("partial_averages_in_development_areas") &&
        addClassToWeightedCFRequest && (
          <ModalConfirmDelete
            showModalDelete={true}
            title={t("reportCards:addClassToWeightedCFModal.title")}
            message={t("reportCards:addClassToWeightedCFModal.message")}
            txtBtnAccept={t("global:buttons.accept")}
            txtBtnCancel={t("global:buttons.cancel")}
            acceptButtonVariant="primary"
            fnAcceptButton={() => {
              addClassToWeightedCFRequest.executeUpdate();
              setAddClassToWeightedCFRequest(null);
            }}
            fnCancelButton={() => setAddClassToWeightedCFRequest(null)}
          />
        )}
      {isFeatureEnabled("partial_averages_in_development_areas") &&
        deleteClassRequest && (
          <ModalConfirmDelete
            showModalDelete={true}
            title={t("reportCards:deleteWeightedClassModal.title")}
            message={t("reportCards:deleteWeightedClassModal.message")}
            txtBtnAccept={t("global:buttons.accept")}
            txtBtnCancel={t("global:buttons.cancel")}
            acceptButtonVariant="primary"
            fnAcceptButton={confirmDeleteWeightedClass}
            fnCancelButton={() => setDeleteClassRequest(null)}
          />
        )}
      <LeaveWithoutSavingModal
        show={unsavedChangesGuardEnabled && showLeaveModal}
        saving={saving}
        onStay={onStayInEditor}
        onLeave={onLeaveWithoutSaving}
        onSaveAndLeave={onSaveAndLeave}
      />
    </div>
  );
};

export default ReportCardEditor;

ReportCardEditor.propTypes = {
  match: PropTypes.obj,
};
